/**
 * useJourneyStore — V87.1 Motor de Validação da Jornada do Projeto
 *
 * Persiste overrides manuais de tarefas e expõe helpers de validação
 * de etapa. A validação automática (cycleTime, kaizen bursts) é feita
 * no componente que tem acesso a useVsmStore, usando taskOverrides aqui
 * como camada de persistência.
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ProjectStep } from '../components/ProjectJourneySidebar';

interface JourneyState {
  /** Overrides manuais: { [taskId]: true/false } — persiste entre sessões */
  taskOverrides: Record<string, boolean>;

  /**
   * Retorna true se TODAS as tarefas do step estão completas, levando em
   * conta tanto os overrides manuais quanto os valores automáticos passados.
   */
  isStepValid: (stepId: ProjectStep, completedCount: number, totalCount: number) => boolean;

  /** Alterna o override manual de uma tarefa */
  toggleTask: (taskId: string) => void;

  /** Limpa todos os overrides (ex.: novo projeto) */
  resetOverrides: () => void;
}

export const useJourneyStore = create<JourneyState>()(
  persist(
    (set, get) => ({
      taskOverrides: {},

      isStepValid: (_stepId, completedCount, totalCount) =>
        totalCount > 0 && completedCount >= totalCount,

      toggleTask: (taskId) =>
        set((state) => ({
          taskOverrides: {
            ...state.taskOverrides,
            [taskId]: !state.taskOverrides[taskId],
          },
        })),

      resetOverrides: () => set({ taskOverrides: {} }),
    }),
    {
      name: 'vsm_journey_v87',
      partialize: (state) => ({ taskOverrides: state.taskOverrides }),
    },
  ),
);
